import { createSlice } from "@reduxjs/toolkit";
import initialState from "@app/routes/vocabulary/store/initialState";
import { generateGame, fetchGames, fetchAreaOfNeeds, fetchThemes, fetchGrades, fetchReadingGame } from "./vocabularyThunks";
import { serializedAreaOfNeeds } from "../serializers";

const simpleSetPayload = (stateField) => (state, action) => { state[stateField] = action.payload; };
const simpleSetWathClearError = (stateField) => (state, action) => { state[stateField] = action.payload; state.generateGameError = false; };

const setSelectedFilterByType = (subField) => (state, action) => ({
  ...state,
  selectedFilter: {
    ...(state.selectedFilter || {}),
    [subField]: action.payload,
  },
});

export const vocabularySlice = createSlice({
  name: "vocabulary",
  initialState,
  reducers: {
    //vocabulary
    setCategories: simpleSetPayload("categories"),
    setIsLoadingCategories: simpleSetPayload("isLoadingCategories"),
    setSelectedCategories: simpleSetWathClearError("selectedCategories"),
    setWordTypes: simpleSetPayload("wordTypes"),

    //Articulation/ Phonological
    setSounds: simpleSetPayload("sounds"),
    setSoundPositions: simpleSetPayload("soundPositions"),
    setSelectedArticulationSounds: simpleSetWathClearError("selectedArticulationSounds"),
    setSelectedArticulationSoundPositions: simpleSetWathClearError("selectedArticulationSoundPositions"),
    
    //other
    setNumOfSyllables: simpleSetPayload("numOfSyllables"),
    setSyllablesShapes: simpleSetPayload("syllablesShapes"),

    setGrades: simpleSetPayload("grades"),
    setThemes: simpleSetPayload("themes"),
    setCCSSMeta: simpleSetPayload("ccssMeta"),

    setSelectedGame: simpleSetWathClearError("selectedGame"),
    setIsLoadingGame: simpleSetPayload("isLoadingGame"),
    setGenerateGameError: simpleSetPayload("generateGameError"),

    setSearchText: simpleSetPayload("searchText"),
    setTrackEventsFunc: simpleSetPayload("trackEventsFunc"),

    clearArticulationFilters: (state) => ({
      ...state,
      selectedArticulationSoundPositions: [],
      numOfSyllables: [],
      syllablesShapes: [],
      selectedArticulationSounds: [],
    }),

    clearVocabularyFilters: (state) => ({
      ...state,
      selectedCategories: [],
    }),
    clearAllFilter: (state) => ({
      ...state,
      selectedArticulationSoundPositions: [],
      selectedArticulationSounds: [],
      selectedCategories: [],
      selectedGrades: {},
      numOfSyllables: [],
      syllablesShapes: [],
      generateGameError: false,
    }),

    setGames: simpleSetPayload("games"),
    setAreaOfNeeds: simpleSetPayload("areaOfNeeds"),

    setSelectedFilter: simpleSetPayload("selectedFilter"),
    setSelectedGrades: setSelectedFilterByType("grades"),
    setSelectedThemes: setSelectedFilterByType("themes"),
    setSelectedCCSSs: setSelectedFilterByType("ccss"),
  },
  extraReducers: {
    // [generateGameUrl.fulfilled]: (state, action) => {
    //   state.words = action?.payload?.words || [];
    // },
    [generateGame.pending]: (state) => {
      state.isLoadingGame = true;
      state.generateGameError = false;
    },
    [generateGame.fulfilled]: (state) => {
      state.isLoadingGame = false;
    },
    [generateGame.rejected]: (state) => {
      state.isLoadingGame = false;
      state.generateGameError = true;
    },
    
    [fetchGames.pending]: (state) => {
      state.isLoadingGames = true;
    },
    [fetchGames.fulfilled]: (state, action) => {
      state.games = action.payload;
      state.isLoadingGames = false;
    },
    [fetchGames.rejected]: (state) => {
      state.isLoadingGames = false;
    },

    [fetchReadingGame.pending]: (state) => {
      state.isLoadingGame = true;
      state.generateGameError = false;
    },
    [fetchReadingGame.fulfilled]: (state) => {
      state.isLoadingGame = false;
    },
    [fetchReadingGame.rejected]: (state) => {
      state.isLoadingGame = false;
      state.generateGameError = true;
    },

    [fetchAreaOfNeeds.pending]: (state) => {
      state.isLoadingAreaOfNeeds = true;
    },
    [fetchAreaOfNeeds.fulfilled]: (state, action) => {
      const obj = serializedAreaOfNeeds(action.payload);

      state.objectivesColors = obj.objectivesColors;
      state.areaOfNeeds = obj.areaOfNeeds;
      state.gamesRelations = obj.gamesRelations;
      state.isLoadingAreaOfNeeds = false;
    },
    [fetchAreaOfNeeds.rejected]: (state) => {
      state.isLoadingAreaOfNeeds = false;
    },
    
    [fetchThemes.fulfilled]: (state, action) => {
      const { response } = action.payload;
      state.themes = response.map(i => ({ value: `${i.id}`, label: i.name }));
    },
    [fetchGrades.fulfilled]: (state, action) => {
      const { response } = action.payload;
      state.grades = response.map(i => ({ value: i.label, label: i.label })); // name is server enam id
    },
  },
});

export const {
  setSelectedCategories,
  setNumOfSyllables,
  setSyllablesShapes,
  setCategories,
  setIsLoadingCategories,
  setWordsLimit,
  setSelectedGame,
  setIsLoadingGame,
  setGenerateGameError,
  setSelectedArticulationSoundPositions,
  setSelectedArticulationSounds,
  setGrades,
  setSelectedGrades,
  setThemes,
  setSelectedThemes,
  setCCSSMeta,
  setSelectedCCSSs,
  setSoundPositions,
  setSounds,
  setWordTypes,
  setSearchText,
  clearArticulationFilters,
  clearPhonologicalFilters,
  clearVocabularyFilters,
  clearAllFilter,
  
  setGames,
  setAreaOfNeeds,
  setSelectedFilter,
  setTrackEventsFunc,
} = vocabularySlice.actions;

export default vocabularySlice.reducer;
